// Supabase public anon key
export const publicAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhkcWRrd3BmaWhyYXBlY3pjZXFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAyMjEzMzQsImV4cCI6MjA4NTc5NzMzNH0.9DNnz--AdxHfBsPmFZ9GjOis9D9WochpXFonfg0dzUU';
